import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
const META_PIXEL_ID = '1251837510200280';
/**
 * Sends a pixel event via image request as a guaranteed fallback.
 * This ensures the event reaches Facebook even if the JS SDK hasn't loaded.
 */
export function sendPixelEvent(eventName: string, params?: Record<string, any>) {
  // 1. Try the JS SDK first
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
  // 2. Image pixel fallback — always fires regardless of SDK state
  try {
    const img = new Image(1, 1);
    const queryParams = new URLSearchParams({
      id: META_PIXEL_ID,
      ev: eventName,
      noscript: '1'
    });
    if (params) {
      queryParams.set('cd[content_name]', params.content_name || '');
      queryParams.set('cd[content_type]', params.content_type || '');
      queryParams.set('cd[value]', String(params.value || ''));
      queryParams.set('cd[currency]', params.currency || 'USD');
    }
    img.src = `https://www.facebook.com/tr?${queryParams.toString()}`;
  } catch (e) {
    // Silent fail
  }
}
export function App() {
  useEffect(() => {
    // ── Meta Pixel: single initialization ──
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    // Fire PageView via SDK
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    // Noscript fallback for PageView
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    document.body.appendChild(noscriptImg);
    // ── Check for Hotmart purchase confirmation redirect ──
    const urlParams = new URLSearchParams(window.location.search);
    const purchaseStatus = urlParams.get('purchase') || urlParams.get('status') || urlParams.get('transaction') || urlParams.get('hotmart_status');
    if (purchaseStatus === 'approved' || purchaseStatus === 'complete' || purchaseStatus === 'success') {
      sendPixelEvent('Purchase', {
        content_name: 'Celular bajo control, hogar en paz',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
    // ── SEO: inject meta tags ──
    document.documentElement.lang = 'es';
    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };
    document.title = 'Celular bajo control, hogar en paz — Guía para mamás | $6.36';
    setMeta('description', 'Plan de 30 días para poner límites al celular sin gritos y recuperar la conexión con tu adolescente. Guía práctica para mamás hispanas en EE.UU. Descarga inmediata por solo $6.36.');
    setMeta('robots', 'index, follow');
    setMeta('author', 'Conexión Primero');
    setMeta('viewport', 'width=device-width, initial-scale=1');
    // Open Graph
    setMeta('og:title', 'Celular bajo control, hogar en paz — Guía para mamás', true);
    setMeta('og:description', 'Plan de 30 días para poner límites al celular sin gritos. Descarga inmediata por $6.36.', true);
    setMeta('og:type', 'product', true);
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png', true);
    setMeta('og:locale', 'es_US', true);
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Celular bajo control, hogar en paz — Guía para mamás');
    setMeta('twitter:description', 'Plan de 30 días para poner límites al celular sin gritos. Descarga inmediata por $6.36.');
    setMeta('twitter:image', 'https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png');
    // Structured Data (JSON-LD)
    const existingLd = document.querySelector('script[data-ld="product"]');
    if (!existingLd) {
      const ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.setAttribute('data-ld', 'product');
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Celular bajo control, hogar en paz',
        description: 'Plan de 30 días para poner límites al celular sin gritos y recuperar la conexión con tu adolescente.',
        image: 'https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png',
        brand: {
          '@type': 'Brand',
          name: 'Conexión Primero'
        },
        offers: {
          '@type': 'Offer',
          price: '6.36',
          priceCurrency: 'USD',
          availability: 'https://schema.org/InStock',
          url: 'https://pay.hotmart.com/O104832352I'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.7',
          reviewCount: '3'
        }
      });
      document.head.appendChild(ld);
    }
  }, []);
  return <SalesPage data-id="element-0" />;
}